import React from 'react'
import { useTranslation } from 'react-i18next'
import Modal from 'components/common/modals-slideouts/Modal'
import Button from 'components/common/buttons/Button'

const FAQModal = ({
  isFaqOpen,
  setIsFaqOpen,
}: {
  isFaqOpen: boolean
  setIsFaqOpen: (isOpen: boolean) => void
}) => {
  const { t } = useTranslation('pub', {
    keyPrefix: 'PublicRoutes',
  })

  const handleClose = () => setIsFaqOpen(false)

  const mcBenefitRedemptionBlock: JSX.Element = (
    <div className="QandAblock">
      <p className="question">{t('faq.questions.mcBenefitRedemption')}</p>
      <p className="answer">{t('faq.answers.mcBenefitRedemption.p1')}</p>
      <p className="answer">{t('faq.answers.mcBenefitRedemption.p2')}</p>
    </div>
  )

  const whatIsMyCyberRiskBlock: JSX.Element = (
    <div className="QandAblock">
      <p className="question">{t('faq.questions.whatIsMyCyberRisk')}</p>
      <p className="answer">{t('faq.answers.whatIsMyCyberRisk')}</p>
    </div>
  )

  const whatDoesMCRDetectBlock: JSX.Element = (
    <div className="QandAblock">
      <p className="question">{t('faq.questions.whatDoesMCRDetect')}</p>
      <p className="answer">{t('faq.answers.whatDoesMCRDetect')}</p>
    </div>
  )

  const whatAreTheBenefitsBlock: JSX.Element = (
    <div className="QandAblock">
      <p className="question">{t('faq.questions.whatAreTheBenefits')}</p>
      <p className="answer">{t('faq.answers.whatAreTheBenefits.p1')}</p>
      <p className="answer">{t('faq.answers.whatAreTheBenefits.p2')}</p>
      <ul>
        <li>
          <span className="bold">
            {t('faq.answers.whatAreTheBenefits.l1B')}
          </span>{' '}
          {t('faq.answers.whatAreTheBenefits.l1T')}
        </li>
        <li>
          <span className="bold">
            {t('faq.answers.whatAreTheBenefits.l2B')}
          </span>{' '}
          {t('faq.answers.whatAreTheBenefits.l2T')}
        </li>
        <li>
          <span className="bold">
            {t('faq.answers.whatAreTheBenefits.l3B')}
          </span>{' '}
          {t('faq.answers.whatAreTheBenefits.l3T')}
        </li>
        <li>
          <span className="bold">
            {t('faq.answers.whatAreTheBenefits.l4B')}
          </span>{' '}
          {t('faq.answers.whatAreTheBenefits.l4T')}
        </li>
      </ul>
    </div>
  )

  const setupTimeBlock: JSX.Element = (
    <div className="QandAblock">
      <p className="question">{t('faq.questions.setupTime')}</p>
      <p className="answer">{t('faq.answers.setupTime')}</p>
    </div>
  )

  const reportContentsBlock: JSX.Element = (
    <div className="QandAblock">
      <p className="question">{t('faq.questions.reportContents')}</p>
      <p className="answer">{t('faq.answers.reportContents')}</p>
    </div>
  )

  const afterScoreBlock: JSX.Element = (
    <div className="QandAblock">
      <p className="question">{t('faq.questions.afterScore')}</p>
      <p className="answer">{t('faq.answers.afterScore')}</p>
    </div>
  )

  const businessInfoAccessBlock: JSX.Element = (
    <div className="QandAblock">
      <p className="question">{t('faq.questions.businessInfoAccess')}</p>
      <p className="answer">{t('faq.answers.businessInfoAccess')}</p>
    </div>
  )

  const riskUpdateFrequencyBlock: JSX.Element = (
    <div className="QandAblock">
      <p className="question">{t('faq.questions.riskUpdateFrequency')}</p>
      <p className="answer">{t('faq.answers.riskUpdateFrequency')}</p>
    </div>
  )

  const whyUseThisOverOthersBlock: JSX.Element = (
    <div className="QandAblock">
      <p className="question">{t('faq.questions.whyUseThisOverOthers')}</p>
      <p className="answer">{t('faq.answers.whyUseThisOverOthers')}</p>
    </div>
  )

  const subscriptionDurationBlock: JSX.Element = (
    <div className="QandAblock">
      <p className="question">{t('faq.questions.subscriptionDuration')}</p>
      <p className="answer">{t('faq.answers.subscriptionDuration')}</p>
    </div>
  )

  const willIBeChargedBlock: JSX.Element = (
    <div className="QandAblock">
      <p className="question">{t('faq.questions.willIBeCharged')}</p>
      <p className="answer">{t('faq.answers.willIBeCharged')}</p>
    </div>
  )

  return (
    <Modal isOpen={isFaqOpen} close={handleClose}>
      <div className="faq-modal-wrapper">
        <div className="faq-modal-header">
          <h2>{t('faq.frequentlyAskedQuestions')}</h2>
        </div>
        <div className="faq-modal-content">
          <div>
            {mcBenefitRedemptionBlock}
            {whatIsMyCyberRiskBlock}
            {whatDoesMCRDetectBlock}
            {whatAreTheBenefitsBlock}
            {setupTimeBlock}
            {reportContentsBlock}
            {afterScoreBlock}
            {businessInfoAccessBlock}
            {riskUpdateFrequencyBlock}
            {whyUseThisOverOthersBlock}
            {subscriptionDurationBlock}
            {willIBeChargedBlock}
          </div>
        </div>
        <div className="faq-modal-footer">
          <Button color="dark" onClick={handleClose}>
            {t('faq.close')}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default FAQModal
